export default __webpack_public_path__ + "static/media/iceberg.53ee0374.png";